import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { MenuPopUp } from "./menuPopUp";
import { useState } from "react";
import { useLogin } from "@/hooks/useLogin";
import { IconChevronDown } from "@/components/icons/chevronDown";

type Props = {
  title: string;
};

// ─── Avatar com iniciais ──────────────────────────────────────────────────────

const InitialsAvatar = ({ name }: { name?: string }) => {
  const initials = name
    ? name
        .split(" ")
        .slice(0, 2)
        .map((n) => n[0])
        .join("")
        .toUpperCase()
    : "?";

  return (
    <Box
      w="28px"
      h="28px"
      borderRadius="full"
      bg="primary.500"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      <Text
        fontFamily="Inter"
        fontWeight="700"
        fontSize="10px"
        color="neutral.700"
        letterSpacing="0.05em"
        lineHeight={1}
      >
        {initials}
      </Text>
    </Box>
  );
};

// ─── Componente ───────────────────────────────────────────────────────────────

export const TopBar = ({ title }: Props) => {
  const [showMenuPopUp, setShowMenuPopUp] = useState(false);
  const { getAccount } = useLogin();

  const accountName = getAccount()?.name;

  return (
    <HStack
      w="100%"
      h="52px"
      flexShrink={0}
      justifyContent="space-between"
      alignItems="center"
      bgColor="neutral.500"
      borderLeft="1px solid"
      borderLeftColor="neutral.600"
      borderBottom="1px solid"
      borderBottomColor="whiteAlpha.100"
      pl={6}
      pr={2}
      position="relative"
      _after={{
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        w: "160px",
        h: "1px",
        bgGradient: "linear(to-r, primary.500, transparent)",
        opacity: 0.5,
        pointerEvents: "none",
      }}
    >
      {/* ── Título ── */}
      <HStack spacing={3}>
        <Box
          w="2px"
          h="16px"
          bg="primary.500"
          borderRadius="2px"
          flexShrink={0}
        />
        <Text
          fontFamily="Manrope"
          fontWeight="700"
          fontSize="15px"
          lineHeight={1}
          color="neutral.50"
          letterSpacing="0.01em"
        >
          {title}
        </Text>
      </HStack>

      {/* ── Usuário ── */}
      <Box position="relative">
        <Button
          variant="ghost"
          h="36px"
          px={3}
          gap={2}
          borderRadius={6}
          color="neutral.200"
          _hover={{ bg: "whiteAlpha.100", color: "neutral.0" }}
          _active={{ bg: "whiteAlpha.150" }}
          onClick={() => setShowMenuPopUp((prev) => !prev)}
        >
          <InitialsAvatar name={accountName} />

          <Text
            fontFamily="Inter"
            fontWeight="500"
            fontSize="13px"
            maxW="140px"
            noOfLines={1}
          >
            {accountName}
          </Text>

          <Box
            color="neutral.400"
            transform={showMenuPopUp ? "rotate(180deg)" : "rotate(0deg)"}
            transition="transform 0.2s ease"
          >
            <IconChevronDown />
          </Box>
        </Button>

        {showMenuPopUp && <MenuPopUp />}
      </Box>
    </HStack>
  );
};
